import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

const COLORS = {
  primaryBlue: "#1A4F8A",
  primaryDark: "#0D3366",
  successGreen: "#2E7D32",
  warningAmber: "#F57C00",
  dangerRed: "#C62828",
  backgroundGray: "#F5F7FA",
  mutedText: "#546E7A",
  border: "#B0C4DE",
  white: "#FFFFFF",
  activeNavBg: "#E3EDF7",
};

const menuItems = [
  { name: "Dashboard", path: "/billing/dashboard", icon: "📊" },
  { name: "Camps", path: "/billing/camps", icon: "🏕️" },
  // { name: "Case Entry", path: "/billing/case-entry", icon: "📋" },
  { name: "Billing", path: "/billing/billing", icon: "🧾" },
  // { name: "Audit Log", path: "/billing/audit-log", icon: "📜" },
  { name: "TCS Billing",path: "/billing/tcs-billing",icon: "🏢"},
  { name: "MFI Finance Activation", path: "/billing/mfi-finance", icon: "💳" }
];

const Sidebar = ({ navigate, pathname }) => {
  return (
    <div
      style={{
        width:"240px",
        minWidth:"240px",
        maxWidth:"240px",
        height:"calc(100vh - 56px)",
        background:COLORS.backgroundGray,
        borderRight:`1px solid ${COLORS.border}`,
        display:"flex",
        flexDirection:"column",
        flexShrink:0,
        overflowY:"auto"
      }}
    >
      <div style={{ padding: "24px 20px", borderBottom: `1px solid ${COLORS.border}` }}>
        <h1 style={{ fontSize: "20px", fontWeight: 700, margin: 0, color: COLORS.primaryBlue }}>
          Camp Billing
        </h1>
        <p style={{ fontSize: "11px", color: COLORS.mutedText, margin: "4px 0 0" }}>
          Management Suite
        </p>
      </div>

      <nav style={{ flex: 1, padding: "16px 12px", display: "flex", flexDirection: "column", gap: "4px" }}>
        {menuItems.map((item) => {
          const isActive = pathname === item.path;
          return (
            <div
              key={item.path}
              onClick={() => navigate(item.path)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "10px 16px",
                borderRadius: "8px",
                cursor: "pointer",
                background: isActive ? COLORS.activeNavBg : "transparent",
                borderLeft: isActive ? `3px solid ${COLORS.primaryBlue}` : "3px solid transparent",
                fontWeight: isActive ? 700 : 500,
                color: isActive ? COLORS.primaryBlue : COLORS.mutedText,
                transition: "all 0.2s",
              }}
            >
              <span style={{ fontSize: "18px" }}>{item.icon}</span>
              <span style={{ fontSize: "14px" }}>{item.name}</span>
            </div>
          );
        })}
      </nav>

      {/* <div style={{ padding: "16px", borderTop: `1px solid ${COLORS.border}`, marginTop: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              background: COLORS.primaryBlue,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: COLORS.white,
              fontWeight: 700,
            }}
          >
            AD
          </div>
          <div>
            <div style={{ fontSize: "13px", fontWeight: 600 }}>Admin User</div>
            <div style={{ fontSize: "11px", color: COLORS.mutedText }}>Billing Manager</div>
          </div>
        </div>
      </div> */}
    </div>
  );
};




const Topbar = ({ onLogout }) => {
  const [camp, setCamp] = useState("Camp Alpha");
  return (
    <div
      style={{
        height: "56px",
        background: COLORS.primaryBlue,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        flexShrink: 0,
        width: "100%",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <span style={{ color: COLORS.white, fontWeight: 700, fontSize: "18px" }}>🏕️ Camp Billing</span>
        {/* <select
          value={camp}
          onChange={(e) => setCamp(e.target.value)}
          style={{
            background: "rgba(255,255,255,0.15)",
            border: `1px solid rgba(255,255,255,0.3)`,
            borderRadius: "6px",
            color: COLORS.white,
            padding: "6px 28px 6px 12px",
            fontSize: "13px",
            cursor: "pointer",
          }}
        >
          <option style={{ color: "#000" }}>Camp Alpha</option>
          <option style={{ color: "#000" }}>Camp Beta</option>
          <option style={{ color: "#000" }}>Camp Gamma</option>
        </select> */}
      </div>
      {/* <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <div style={{ position: "relative", cursor: "pointer" }}>
          <span style={{ fontSize: "20px", color: COLORS.white }}>🔔</span>
          <span
            style={{
              position: "absolute",
              top: "-4px",
              right: "-6px",
              background: COLORS.dangerRed,
              width: "10px",
              height: "10px",
              borderRadius: "50%",
            }}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: COLORS.white,
              color: COLORS.primaryBlue,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
            }}
          >
            JD
          </div>
          <span style={{ color: COLORS.white, fontSize: "14px", fontWeight: 500 }}>John Doe</span>
        </div>
      </div> */}
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <button
          onClick={onLogout}
          style={{
            background: COLORS.dangerRed,
            color: "#fff",
            border: "none",
            padding: "6px 12px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 600,
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

const BillingLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    // 1. Clear storage (adjust based on what you use)
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    // or if using sessionStorage
    // sessionStorage.clear();

    // 2. Navigate to login
    navigate("/login");
  };

  useEffect(() => {
    const style = document.createElement("style");

    style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    *{
    margin:0;
    padding:0;
    box-sizing:border-box;
    }

    html,
    body,
    #root{
    width:100%;
    min-width:100%;
    height:100%;
    margin:0 !important;
    padding:0 !important;
    overflow:hidden;
    }

    body{
    background:${COLORS.backgroundGray};
    font-family:'Inter',sans-serif;
    }

    ::-webkit-scrollbar{
    width:6px;
    height:6px;
    }

    ::-webkit-scrollbar-thumb{
    background:${COLORS.border};
    border-radius:4px;
    }
    `;

    document.head.appendChild(style);

    return () => document.head.removeChild(style);

    }, []);

  return (
    <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, display:"flex", flexDirection:"column", width:"100%", height:"100%", margin:0, padding:0 }} >
      <Topbar onLogout={handleLogout} />
      <div style={{ display:"flex", flex:1, width:"100%", height:"calc(100vh - 56px)", overflow:"hidden"}} >
        <Sidebar navigate={navigate} pathname={location.pathname} />
        <main
          style={{
          flex:1,
          width:"100%",
          minWidth:0,
          height:"100%",
          background:"#fff",
          overflowY:"auto",
          overflowX:"hidden",
          padding:"24px"
          }}
          >
          <Outlet/>
        </main>
      </div>
    </div>
  );
};

export default BillingLayout;